import React, { useMemo } from "react"
import PropTypes from "prop-types"

import { useSelector } from "react-redux"
import Spinner from "components/common/Spinner"
import styles from "../../../Calendar.module.css"
import CalendarTimeGrid from "../../CalendarTimeGrid"

import useSearchFilter from "hooks/useSearchFilter"
const Week = ({ date, activeTab, crewIds, equipmentIds, categoryIds, roleIds }) => {
  const { loading, bookings } = useSelector((state) => state.calendar)
  const [params] = useSearchFilter({ accessAttributes: ["agenda"] })

  const events = useMemo(() => {
    let filtered
    if (activeTab === "equipment") {
      filtered = bookings?.filter((b) => b.assigned_equipment?.length > 0)
    } else if (activeTab === "crew") {
      filtered = bookings
    } else {
      filtered = bookings
    }
    return filtered?.map((booking) => ({
      id: booking?.uuid,
      start: booking?.start_time,
      end: booking?.end_time,
      title: booking?.experience_name,
      date: booking?.date,
      payment_status: booking?.payment_status,
      booking_status: booking?.booking_status,
      assigned_crew: booking?.assigned_crew || [],
      assigned_equipment: booking?.assigned_equipment || [],
    }))
  }, [bookings, activeTab])

  return (
    <>
      <CalendarTimeGrid type="week" date={date} events={events} agenda={params.agenda === true} activeTab={activeTab} crewIds={crewIds} equipmentIds={equipmentIds} categoryIds={categoryIds} roleIds={roleIds} />
      {loading && <Spinner className={styles.spinner} absolute />}
    </>
  )
}

Week.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  activeTab: PropTypes.string,
  crewIds: PropTypes.array,
  equipmentIds: PropTypes.array,
  categoryIds: PropTypes.array,
  roleIds: PropTypes.array,
}

export default Week
